import { Helmet } from "react-helmet";
import SolutionItemHero from "../../components/reusables/hero/SolutionItemHero";
import Authority from "../../components/reusables/Authority";
import HowWeWork from "../../components/solutions/HowWeWork";
import SolutionCTA from "../../components/solutions/SolutionCTA";
import SMManagement from "../../components/solutions/social-media-management/SMManagement";
import SMManagementFaqsBody from "../../components/faqs/SMManagementFaqsBody";
import RelatedSMManagement from "../../components/solutions/social-media-management/RelatedSMManagement";

export default function SocialMediaManagement() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/social-media-management"
        />
        <meta
          name="description"
          content="Get your social media management and account growth done right. From professional account setup, growth, content creation to community engagement."
        />

        <meta
          property="og:description"
          content="Get your social media management and account growth done right. From professional account setup, growth, content creation to community engagement."
        />
        <meta
          property="og:title"
          content="NTUNA.COM | Solutions | Social Media Management & Account Growth"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM | Solutions | Social Media Management & Account Growth"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Solutions | Social Media Management & Account Growth"
        />
        <meta
          name="twitter:description"
          content="Get your social media management and account growth done right. From professional account setup, growth, content creation to community engagement."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />
        <title>
          NTUNA.COM | Solutions | Social Media Management & Account Growth
        </title>
      </Helmet>
      <SolutionItemHero
        title="Social Media Management & Account Growth"
        subtitle="Get your social media accounts setup and managed right. We create, manage, and optimize your social presence with consistent content, real engagement, and strategies that drive measurable growth."
        casestudylink="/#"
        CTAtext="Get Free Quote"
        mainCTAlink="https://form.jotform.com/ntuna/get-free-quote"
      />
      <Authority />
      <SMManagement />
      <SolutionCTA ctaTitle="Ready To Have Your Social Media Accounts Setup & Managed Right?" />
      <SMManagementFaqsBody />
      <SolutionCTA ctaTitle="Ready To Have Your Social Media Accounts Setup & Managed Right?" />
      <HowWeWork />
      <SolutionCTA ctaTitle="Ready To Have Your Social Media Accounts Setup & Managed Right?" />
      <RelatedSMManagement />
    </>
  );
}
